<template>
  <UserDetail
    v-if="loaded && selectedUser"
    :user="selectedUser"
    :user-roles="userRoles"
    :password-min-length="passwordMinLength"
    :user-added="userAdded"
    @updateUser="editUser" />
  <Page404
    v-else-if="loaded"
    message="That user was not found" />
</template>
<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import recordUpdatedNotify from 'src/mixins/showUpdateNotification';
import Page404 from 'src/components/NotFoundPage.vue';
import UserDetail from './_components/UserDetail.vue';

export default {
  name: 'UserDetailModule',
  components: {
    UserDetail,
    Page404,
  },
  mixins: [recordUpdatedNotify],
  computed: {
    ...mapState('user', {
      userRoles: state => state.userRoles,
      selectedUser: state => state.selectedUser,
      passwordMinLength: state => state.passwordMinLength,
    }),
  },
  async created() {
    await this.fetchUser({ id: this.$route.params.id });
    this.loaded = true;
    this.subscribeToUserUpdated();
  },
  beforeDestroy() {
    this.unsubscribeToUserUpdated();
    this.clearSelectedUser();
    // clear all the notifications related to this module
    this.$notifications.removeAll();
  },
  data() {
    return {
      loaded: false,
      firstLoad: true,
      shouldNotify: true,
      userAdded: false,
    };
  },
  methods: {
    ...mapActions('user', [
      'fetchUser',
      'clearSelectedUser',
      'subscribeToUserUpdated',
      'unsubscribeToUserUpdated',
      'addUser',
      'updateUser',
    ]),
    async editUser(update) {
      await this.updateUser(update);
    },
  },
  watch: {
    selectedUser: _.debounce(function updated(record, oldRecord) {
      this.showUpdateNotification({ record, oldRecord });
    }, 500, { trailing: true }),
  },
};
</script>
